import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '@shared/shared.module';

import { ContractProductUtilizationPageRoutingModule } from './contract-product-utilization-routing.module';
import { ContractProductUtilizationPageComponent } from './contract-product-utilization.page';
import { CustomerReportingComponentsSharedModule } from '../../components-shared/customer-reporting-components-shared.module';
@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ContractProductUtilizationPageRoutingModule,
    SharedModule,
    CustomerReportingComponentsSharedModule,
  ],
  declarations: [ContractProductUtilizationPageComponent],
})
export class ContractProductUtilizationPageModule {}
